import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
import ProfileMenu from './ProfileMenu';
import { FiHome, FiBarChart2, FiSun, FiMoon, FiPlus, FiZap, FiLogIn, FiRefreshCw, FiBookOpen } from 'react-icons/fi';

export default function Navbar() {
  const { streak, theme, toggleTheme, syncStatus } = useApp();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const streakLevel = streak.current >= 100 ? 'legendary' :
    streak.current >= 30 ? 'blazing' :
    streak.current >= 7 ? 'warm' : 'spark';

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <div className="navbar-brand" onClick={() => navigate('/')} role="button" tabIndex={0}>
          <div className="brand-icon">
            <FiZap />
          </div>
          <span className="brand-text">Recall</span>
        </div>

        <div className="navbar-links">
          <NavLink to="/" end className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            <FiHome />
            <span>Decks</span>
          </NavLink>
          <NavLink to="/library" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            <FiBookOpen />
            <span>Library</span>
          </NavLink>
          <NavLink to="/stats" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            <FiBarChart2 />
            <span>Stats</span>
          </NavLink>
        </div>

        <div className="navbar-actions">
          {isAuthenticated && syncStatus === 'syncing' && (
            <div className="sync-indicator" title="Syncing...">
              <FiRefreshCw className="sync-spinning" />
            </div>
          )}
          {streak.current > 0 && (
            <div className={`streak-badge ${streakLevel}`} title={`${streak.current} day streak`}>
              <span className="streak-flame">🔥</span>
              <span className="streak-count">{streak.current}</span>
            </div>
          )}
          <button className="nav-btn" onClick={() => navigate('/decks/new')} title="Create deck">
            <FiPlus />
          </button>
          <button className="nav-btn" onClick={toggleTheme} title="Toggle theme">
            {theme === 'dark' ? <FiSun /> : <FiMoon />}
          </button>
          {isAuthenticated ? (
            <ProfileMenu />
          ) : (
            <button className="nav-btn" onClick={() => navigate('/login')} title="Sign in">
              <FiLogIn />
            </button>
          )}
        </div>
      </div>

    </nav>
  );
}
